const Videos = () => {

    const heroSection = document.querySelector('.hero-movie');
    const videoElement = heroSection?.querySelector('video');

    if (!heroSection || !videoElement) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                videoElement.play(); // Uruchamia film, gdy sekcja jest widoczna
                // console.log('start video')
            } else {
                // videoElement.pause(); // Pauzuje film, gdy sekcja nie jest widoczna
                // console.log('stop')
            }
        });
    }, {
        root: null, // Obserwacja w kontekście okna
        threshold: 0.1 // Sekcja musi być widoczna w 50%, aby zareagować
    });

    observer.observe(heroSection);

}

export default Videos;